<template>
  <AdminLayout />
</template>

<script setup>
// Nama komponen secara implisit akan menjadi AdminWrapper
import AdminLayout from '@/layouts/AdminLayout.vue';
</script>s